import React from 'react';

import Check from '@/components/ui/icons/Check';
import CrossFill from '@/components/ui/icons/CrossFill';

import classes from './EditorControls.module.scss';

interface EditorControlsProps {
	isDisabled: boolean;
	onSave?: () => void;
	onCancel?: () => void;
}

export const EditorControls: React.FC<EditorControlsProps> = ({ isDisabled, onSave, onCancel }) => {
	return (
		<div className={classes.editorControls}>
			<button
				title='Сохранить'
				disabled={isDisabled}
				type='button'
				className={classes.save}
				onClick={() => onSave?.()}
			>
				<Check clazz={classes.saveIcon} />
			</button>
			<button
				title='Отмена'
				type='button'
				className={classes.cancel}
				onClick={() => onCancel?.()}
			>
				<CrossFill clazz={classes.cancelIcon} />
			</button>
		</div>
	);
};
